// extracted by mini-css-extract-plugin
export default {"video":"style-module__video___UsEAo"};
    if(module.hot) {
      // 1697460475198
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  